import { gql } from "apollo-angular";

export const GET_PUBLISHED_PRICELISTS = gql`
    query GetPublishedPricelists($supplyType: String) {
        publishedPricelists(supplyType: $supplyType) {
            id
            featured
            supplyType
            brands
            mov
            moq
            leadTimeFrom
            leadTimeTo
            prePaymentPercentage
            fullPackageOnly
            preOrderShippingDate
            highlights
            promotionDescription
            promotionTextColor
            volumeDiscounts
        }
    }
`;

export const GET_PREORDER_BRAND_METRICS = gql`
    query GetPreOrderBrandMetrics {
        preOrderBrandMetrics {
            totalSkuCount
            items { brand offerId skuCount retailDiscountPercent matchedSkuCount categories }
        }
    }
`;
